// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';


export {
  SET_CURRENT_PAGE,
};
